import React from "react";

import { useRouter } from "./useRouter";

interface Props {
  routeParam: string;
  views: {
    [key: string]: ((active: boolean, index: number) => JSX.Element) | undefined;
  };
}

const RoutedTabsComponent: React.FC<Props> = ({ views, routeParam }) => {
  const { searchParams } = useRouter<any, any>();

  const visibleRoutes = Object.keys(views);

  if (!visibleRoutes.length) {
    return null;
  }

  const paramValue = searchParams[routeParam];
  const foundIndex = visibleRoutes.findIndex(routeName => routeName === paramValue);
  const activeIndex = foundIndex === -1 ? 0 : foundIndex;

  return (
    <>
      {visibleRoutes.map((viewName, index) => {
        const render = views[viewName];
        return render?.(activeIndex === index, index);
      })}
    </>
  );
};

export const RoutedTabs = React.memo(RoutedTabsComponent);
